import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-unsaved-changes-icon',
  imports: [],
  templateUrl: './unsaved-changes-icon.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './unsaved-changes-icon.scss',
})
export class UnsavedChangesIcon {}
